import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function ProjectCarousel() {
  const projectImages = [{
    src: 'https://cdn.magicpatterns.com/uploads/7UuJuCytxm3m65uyKHoQh7/imagen1.webp',
    alt: 'Mesa infinita LED azul con marco negro'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/wTdjBHyMhbCbNbqYzzX8ku/imagen_2.webp',
    alt: 'Mesa hexagonal con jardín infinito'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/k1Gp1tdCXJJUsb8f58V31m/imagen_3.webp',
    alt: 'Mesa de audio con ondas LED multicolor'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/eQu4LuKWCAMeis7YJVvG6B/imagen_4.webp',
    alt: 'Escritorio gamer con LED RGB multicolor'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/kR8mRgrispzppgQUSnWAXv/imagen_5.webp',
    alt: 'Mesa hexagonal con panal de abeja LED'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/8NFzXuwQy6xQKRYKgSniva/imagen_6.webp',
    alt: 'Escritorio gaming LED con setup completo'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/bbftRxa24RoK7GRfVEnzjA/imagen_7.webp',
    alt: 'Mesas altas LED para bar o restaurante'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/vvcJsSws9M9ubmcyW1Sjgk/imagen_8.webp',
    alt: 'Mesa redonda LED con patas de madera'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/bPXikrSfmbe7u7d5L8ASBp/imagen_9.webp',
    alt: 'Mesa infinita LED multicolor con efecto de puntos'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/3n2HHvKFCQ6F68tQ5EBU7N/imagen_10.webp',
    alt: 'Mesa infinita con efecto galaxia espacial'
  }];
  // Duplicate the array to create a seamless infinite loop
  const duplicatedImages = [...projectImages, ...projectImages];
  return <section className="py-10 px-4 relative z-10 bg-[#121212] overflow-hidden border-y border-[#27272a]" data-id="element-288">
      <style data-id="element-289">
        {`
          @keyframes scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .animate-scroll {
            animation: scroll 50s linear infinite;
          }
          .animate-scroll:hover {
            animation-play-state: paused;
          }
        `}
      </style>

      <div className="max-w-3xl mx-auto" data-id="element-290">
        <div className="text-center mb-12" data-id="element-291">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#130a2a] border border-[#27272a] text-sm font-bold mb-6 tracking-wide text-[#15E52E]" data-id="element-292">
            <span className="relative flex h-2 w-2" data-id="element-293">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#dc2626] opacity-75" data-id="element-294"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-[#dc2626]" data-id="element-295"></span>
            </span>
            ✨ PROYECTOS REALES
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-4 tracking-tight leading-[1.1] uppercase" data-id="element-296">
            INSPIRACIÓN INFINITA
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-gray-400 max-w-2xl mx-auto font-medium" data-id="element-297">
            Mirá lo que podés crear con las técnicas del ebook
          </motion.p>
        </div>

        {/* Marquee Container */}
        <div className="relative w-full overflow-hidden py-8" data-id="element-298">
          {/* Left and Right fade gradients for smooth edges */}
          <div className="absolute left-0 top-0 bottom-0 w-12 md:w-24 bg-gradient-to-r from-[#121212]/60 to-transparent z-10 pointer-events-none" data-id="element-299" />
          <div className="absolute right-0 top-0 bottom-0 w-12 md:w-24 bg-gradient-to-l from-[#121212]/60 to-transparent z-10 pointer-events-none" data-id="element-300" />

          {/* Scrolling Track */}
          <div className="flex w-max animate-scroll gap-6 px-4" data-id="element-301">
            {duplicatedImages.map((image, index) => <div key={index} className="w-80 md:w-96 h-64 md:h-72 shrink-0 transition-transform duration-500 hover:scale-105 hover:z-20 cursor-pointer group" data-id="element-302">
                <div className="relative w-full h-full overflow-hidden rounded-2xl shadow-[0_10px_40px_rgba(220,38,38,0.3)] border border-red-900/20 group-hover:border-red-500/40 transition-colors" data-id="element-303">
                  <img src={image.src} alt={image.alt} width={384} height={288} className="w-full h-full object-cover" loading="lazy" decoding="async" data-id="element-304" />
                  {/* Overlay on hover */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6" data-id="element-305">
                    <p className="text-white font-bold text-base" data-id="element-306">
                      {image.alt}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}